import { ButtonBase, Stack } from "@mui/material"
import { HtmlContainer } from "./HtmlContainer"
import type { BaseContentProps, BaseTextContentProps } from "./types"
import { baseFontSize } from "./constants"
import { StoryContent, StorySlide } from "../../../../models/stories.models"

interface QuizContentProps extends BaseContentProps, BaseTextContentProps {
  currentSlide: StorySlide
}

export const QuizContent = ({
  currentSlide,
  content,
  ...props
}: QuizContentProps) => {
  if (!content.question || !content.opt1) {
    return null
  }

  return (
    <Stack gap={3} style={{ width: "100%" }}>
      <HtmlContainer
        {...props}
        html={content.question}
        textColor={currentSlide.textColor}
      />
      {Array(4)
        .fill("")
        .map((_, index) => {
          const optionKey = `opt${index + 1}` as keyof Pick<
            StoryContent,
            "opt1" | "opt2" | "opt3" | "opt4"
          >
          const optionContent = content[optionKey]

          if (!optionContent) return null

          return (
            <ButtonBase key={optionContent} disableRipple>
              <HtmlContainer
                html={optionContent}
                fontSize={`${baseFontSize - 2}px`}
                fontWeight={400}
                textColor={currentSlide.textColor}
                boxColor={currentSlide.boxColor}
              />
            </ButtonBase>
          )
        })}
    </Stack>
  )
}
